import { render, staticRenderFns } from "./ForumPollRanked.vue?vue&type=template&id=a62fce02&scoped=true"
import script from "./ForumPollRanked.vue?vue&type=script&lang=js"
export * from "./ForumPollRanked.vue?vue&type=script&lang=js"
import style0 from "./ForumPollRanked.vue?vue&type=style&index=0&id=a62fce02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62fce02",
  null
  
)

export default component.exports